export default __webpack_public_path__ + "static/media/photo-5.60fbd5c6.jpg";